import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-our-valores',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './our-valores.component.html',
  styleUrl: './our-valores.component.css'
})
export class OurValoresComponent {

}
